{
  "restoredMessage": "Restauré « {{manufacturer}} {{model}} »",
  "restoreError": "Échec de la restauration. Veuillez réessayer.",
  "emptyState": "Aucun type FAA sur liste noire. Utilisez le bouton « Ignorer » dans l'onglet Correspondance des aéronefs pour exclure les types d'aéronefs non pertinents (drones, ballons, etc.)",
  "headers": {
    "manufacturer": "Constructeur FAA",
    "model": "Modèle FAA",
    "restore": "Restaurer"
  },
  "restoreTooltip": "Restaurer ce type FAA dans l'onglet Correspondance des aéronefs"
}
